"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimestampsForTodayAndYesterday = exports.convertMillisToDate = void 0;
function convertMillisToDate(millis) {
    const date = new Date(millis);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}
exports.convertMillisToDate = convertMillisToDate;
function getTimestampsForTodayAndYesterday() {
    const offset = -2;
    const now = new Date(new Date().getTime() + offset * 3600 * 1000);
    const todayStart = new Date(now);
    todayStart.setUTCHours(0, 0, 0, 0);
    const todayStartTimestamp = todayStart.getTime();
    const todayEnd = new Date(now);
    todayEnd.setUTCHours(23, 59, 59, 999);
    const todayEndTimestamp = todayEnd.getTime();
    const yesterdayStart = new Date(now);
    yesterdayStart.setUTCDate(now.getUTCDate() - 1);
    yesterdayStart.setUTCHours(0, 0, 0, 0);
    const yesterdayStartTimestamp = yesterdayStart.getTime();
    const yesterdayEnd = new Date(now);
    yesterdayEnd.setUTCDate(now.getUTCDate() - 1);
    yesterdayEnd.setUTCHours(23, 59, 59, 999);
    const yesterdayEndTimestamp = yesterdayEnd.getTime();
    return {
        today: {
            start: todayStartTimestamp,
            end: todayEndTimestamp,
        },
        yesterday: {
            start: yesterdayStartTimestamp,
            end: yesterdayEndTimestamp,
        },
    };
}
exports.getTimestampsForTodayAndYesterday = getTimestampsForTodayAndYesterday;
